/**
 * OIDC client configuration for the SPA — the Cognito hosted UI with a single
 * public PKCE client (openspec `cognito-session` REQ-010). Per-tenant login
 * surfaces are out of scope until Epic-21 S12.
 *
 * Every value is injected at build time by infra (`infra/common/frontend-app.ts`
 * → `buildFrontendCognitoConfig`) and read through getters so it reflects the
 * live build config at call time (robust to values injected after module load,
 * e.g. tests).
 * - `domain` is the hosted-UI host (no scheme): `/oauth2/authorize` + `/logout`.
 * - `redirectUri` / `logoutUri` are the exact URLs registered on the pool client.
 * - `scopes` is the space-joined scope string granted to the client.
 */
export const authConfig = {
	get domain(): string {
		return import.meta.env.VITE_COGNITO_DOMAIN
	},
	get clientId(): string {
		return import.meta.env.VITE_COGNITO_CLIENT_ID
	},
	get scopes(): string {
		return import.meta.env.VITE_COGNITO_SCOPES
	},
	get redirectUri(): string {
		return import.meta.env.VITE_COGNITO_REDIRECT_URI
	},
	get logoutUri(): string {
		return import.meta.env.VITE_COGNITO_LOGOUT_URI
	},
	/**
	 * The public PKCE client used only for TOTP enrolment (TO-63 privileged-mfa,
	 * design D2). Optional: an empty value means the stage has no enrolment
	 * client, and the SPA disables "Set up authenticator".
	 */
	get mfaEnrolmentClientId(): string {
		return import.meta.env.VITE_COGNITO_MFA_ENROLMENT_CLIENT_ID ?? ''
	},
}
